import { createContext, useContext } from "react"
import type { CalculatorContextValue } from "./DailyCalculatorProvider"

export const DailyCalculatorContext = createContext<CalculatorContextValue | undefined>(undefined)

export const useDailyCalculator = () => {
  const context = useContext(DailyCalculatorContext)

  if (!context) {
    throw new Error("useDailyCalculator must be used within a DailyCalculatorProvider")
  }

  return context
}
